import React from 'react'

function customNoRowsOverlay(props) {
    return (
        <div>
            <div
                className="ag-overlay-loading-center"
                style={{background:"none", border:"none", borderRadius:"none", boxShadow:"none"}}
            >
                <span>{props.noRowsMessage}</span>
            </div>   
        </div>
    )
}

export default customNoRowsOverlay